import React, { useEffect } from "react";
import { Link, useHistory, useLocation } from 'react-router-dom';
import { AdsGETApiAuth, AdsPOSTApi, AdsPUTApi, signInImage } from "../../../../Constant/api";
import { slugs } from "../../../../Constant/slugs";
import { AlertComponent } from "../../../AlertComponent";
import { CustomButton } from "../../../CustomButtom";
import FileUpload from "../../../FileUpload";
import ImageUpload from "../../../ImageUpload";
import { CustomButtonUnSelect } from "../../../CustomButtomUnselect";
import ReactToPrint, { useReactToPrint } from 'react-to-print';
import converter from 'number-to-words'
import './styles.css'
export default function FormComponent(props) {
  const { FetchData } = props;
  const history = useHistory()
  const [ID, setID] = React.useState(FetchData.id)

  const [Title, setTitle] = React.useState(FetchData.title.rendered)
  const [InvoiceNo, setInvoiceNo] = React.useState(FetchData.meta.invoice_no)
  const [Name, setName] = React.useState(FetchData.meta.name)
  const [InvoiceDate, setInvoiceDate] = React.useState(FetchData.meta.invoice_date)
  const [PanNo, setPanNo] = React.useState(FetchData.meta.pan_no)
  const [Address, setAddress] = React.useState(FetchData.meta.address)
  const [ModeofPayment, setModeofPayment] = React.useState(FetchData.meta.mode_of_payment)
  const [Items, setItems] = React.useState(FetchData.meta.items == "" ? [] : JSON.parse(FetchData.meta.items))
  const [ShowItemsGroupList, setShowItemsGroupList] = React.useState(true)


  const [TotalAmount, setTotalAmount] = React.useState(FetchData.meta.total_amount)
  const [VAT, setVAT] = React.useState(FetchData.meta.vat)
  const [TotalAfterVAT, setTotalAfterVAT] = React.useState(FetchData.meta.total_after_vat)
  const [Remarks1, setRemarks1] = React.useState(FetchData.meta.remarks1)
  const [Remarks2, setRemarks2] = React.useState(FetchData.meta.remarks2)
  const [Remarks3, setRemarks3] = React.useState(FetchData.meta.remarks3)

  const [reload, setReload] = React.useState(false)

  const [AlertShow, setAlertShow] = React.useState(false)
  const [Alertcomp, setAlertcomp] = React.useState("")


  const EditInfo = () => {
    setReload(true)
    var receipt_number = InvoiceNo
    const data = {
      "title": Title,
      "status": "publish",
      "meta": {
        "invoice_no": `${InvoiceNo}`,
        "name": `${Name}`,
        "pan_no": `${PanNo}`,
        "address": `${Address}`,
        "invoice_date": `${InvoiceDate}`,
        "items": JSON.stringify(Items),
        "total_amount": `${TotalAmount}`,
        "vat": `${VAT}`,
        "total_after_vat": `${TotalAfterVAT}`,
        "remarks1": `${Remarks1}`,
        "remarks2": `${Remarks2}`,
        "remarks3": `${Remarks3}`
      }
    }

    if (ID === "") {
      AdsGETApiAuth({ per_page: 1 }, slugs.db_slug_invoices)
        .then(res => {
          receipt_number = Number(res.headers["x-wp-total"]) + 1
          AdsPOSTApi({
            ...data,
            meta: {
              ...data.meta,
              "invoice_no": `${receipt_number}`,
            }
          }, slugs.db_slug_invoices)
            .then((res) => {
              setReload(false)
              setID(res.data.id)
              setAlertShow(true)
              setAlertcomp("Added Successfully")
              history.push(`${slugs.invoices_details}${res.data.slug}`)
            }).catch(err => {
              setReload(false)
              console.log(err)
              setAlertShow(true)
              setAlertcomp(err.response.data.message)
            })
        })
    }
    else
      AdsPUTApi(data, slugs.db_slug_invoices, ID)
        .then((res) => {
          setReload(false)
          setAlertShow(true)
          setAlertcomp(`Successfully Edited`)
        }).catch(err => {
          console.log(err)
          console.warn(err.response.data)
          console.log("Response Status: hello11", err.response.status);
          console.log("Response Headers:", err.response.headers);
          setReload(false)
          setAlertShow(true)
          setAlertcomp(err.response.data.message)
        })
  }
  const invoiceComponentRef = React.useRef(null);
  const invoiceComponentPrint = useReactToPrint({
    content: () => invoiceComponentRef.current,

  })

  return (
    <div>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-10 form-view mb-3">
          <h4><center>Invoice Information</center></h4>
          <table>
            <tbody>
              <tr>
                <td className="col-3">Invoice Name</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Name} placeholder="Name"
                    onChange={(event) => { setName(event.target.value) }}
                  />
                </td>
              </tr>

              <tr>
                <td className="col-3">Invoice No</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={InvoiceNo} placeholder="Invoice No"
                    onChange={(event) => { setInvoiceNo(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Invoice Date</td>
                <td className="col-6">
                  <input className="input-common" disabled
                    value={FetchData.date.slice(0, 10)} placeholder="Invoice Date"
                    onChange={(event) => { setInvoiceDate(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">PAN Number</td>
                <td className="col-6">
                  <input className="input-common"
                    value={PanNo} placeholder="PAN Number"
                    onChange={(event) => { setPanNo(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Address</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Address} placeholder="Address"
                    onChange={(event) => { setAddress(event.target.value) }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Mode of Payment</td>
                <td className="col-6">
                  <CustomButton Data={ModeofPayment} setData={setModeofPayment} DataValue={"Cash"} />
                  <CustomButton Data={ModeofPayment} setData={setModeofPayment} DataValue={"Credit"} />
                  <CustomButton Data={ModeofPayment} setData={setModeofPayment} DataValue={"Online"} />
                  <CustomButton Data={ModeofPayment} setData={setModeofPayment} DataValue={"Cheque"} />
                </td>
              </tr>
              <tr>
                <td className="col-3">Items</td>
                <td className="col-9">
                  {ShowItemsGroupList &&
                    <div style={{ padding: "0 10px" }}>
                      {Object.values(Items).map((item, index) => (
                        <div key={index} style={{ display: "flex", padding: "3px 0" }}>
                          <span style={{ padding: "10px 5px" }}>   {index + 1} . &nbsp;</span>
                          <span>
                            <div>
                              <input className="input-common-items"
                                value={item.name} placeholder="Items"
                                onChange={(event) => {
                                  setItems({
                                    ...Items,
                                    [Object.keys(Items)[index]]: {
                                      ...Object.values(Items)[index],
                                      "name": event.target.value
                                    }
                                  })
                                }}
                              />
                              <input className="input-common-items"
                                value={item.qty} placeholder="QTY" type="number"
                                onChange={(event) => {
                                  var total = Number(event.target.value) * item.rate
                                  var grantTotal = 0;
                                  var allItems = {
                                    ...Items,
                                    [Object.keys(Items)[index]]: {
                                      ...Object.values(Items)[index],
                                      "qty": event.target.value,
                                      "total": total
                                    }
                                  }
                                  var allItemsARray = Object.values(allItems)
                                  for (let i = 0; i < allItemsARray.length; i++) {
                                    console.log()
                                    grantTotal += Number(allItemsARray[i].total)
                                  }
                                  // setTotalAmount(grantTotal)
                                  // setVAT(Math.round(grantTotal * 0.13, 2))
                                  // setTotalAfterVAT(Math.round(grantTotal + grantTotal * 0.13, 2))
                                  setItems(allItems)
                                }}
                              />
                              <input className="input-common-items"
                                value={item.rate} placeholder="Rate" type="number"
                                onChange={(event) => {
                                  var total = Number(event.target.value) * item.qty
                                  var grantTotal = 0;
                                  var allItems = {
                                    ...Items,
                                    [Object.keys(Items)[index]]: {
                                      ...Object.values(Items)[index],
                                      "rate": event.target.value,
                                      "total": total
                                    }
                                  }
                                  var allItemsARray = Object.values(allItems)
                                  for (let i = 0; i < allItemsARray.length; i++) {
                                    console.log()
                                    grantTotal += Number(allItemsARray[i].total)
                                  }
                                  // setTotalAmount(Math.round(grantTotal, 2))
                                  // setVAT(Math.round(grantTotal * 0.13, 2))
                                  // setTotalAfterVAT(Math.round(grantTotal + grantTotal * 0.13, 2))
                                  setItems(allItems)
                                }}
                              />
                              {/* <input className="input-common-items" disabled
                                value={item.total} placeholder="Total"
                              /> */}
                              <input className="input-common-items"
                                value={item.total} placeholder="Rate" type="number"
                                onChange={(event) => {
                                  // var total = Number(event.target.value) * item.qty
                                  var grantTotal = 0;
                                  var rate = Number(event.target.value) / item.qty
                                  var allItems = {
                                    ...Items,
                                    [Object.keys(Items)[index]]: {
                                      ...Object.values(Items)[index],
                                      "rate": rate.toFixed(2),
                                      "total": event.target.value
                                    }
                                  }
                                  setItems(allItems)
                                }}
                              />
                            </div>
                          </span>
                          <span style={{ cursor: "pointer", padding: "10px 5px" }} onClick={() => {
                            var ObjectForDelete = Items
                            var key = Object.keys(Items)[index]
                            // console.log(key, Items)
                            delete ObjectForDelete[key];
                            setItems(ObjectForDelete)
                            setShowItemsGroupList(false)
                            setTimeout(() => {
                              setShowItemsGroupList(true)
                            }, 10)
                          }}>
                            Delete
                          </span>
                        </div>
                      ))}
                      <div className=" col-3" style={{ padding: "0 10px" }}>
                        <div className="sign-in-button-small"
                          onClick={() => {
                            var newValue = {
                              "name": "",
                              "qty": 0,
                              "rate": 0,
                              "total": 0
                            }
                            var lastkey = Object.keys(Items).length == 0 ? -1 : Number(Object.keys(Items)[Object.keys(Items).length - 1])
                            // console.log(lastkey + 1)
                            var newKey = `${lastkey + 1}`
                            var newObject = Items;
                            newObject = {
                              ...Items,
                              [newKey]: newValue
                            }
                            // console.log(newObject)

                            setItems(newObject)
                          }}
                        >
                          Add Item
                        </div>
                      </div>
                    </div>
                  }
                </td>
              </tr>
              <tr>
                <td className="col-3">Total Amount</td>
                <td className="col-6">
                  <div className="input-common">
                    {TotalAmount}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">VAT 13%</td>
                <td className="col-6">
                  <div className="input-common">
                    {VAT}&nbsp;
                  </div>
                </td>
              </tr>
              <tr>
                <td className="col-3">Total after VAT</td>
                <td className="col-6">
                  {/* {TotalAfterVAT}&nbsp; */}
                  <input className="input-common"
                    value={TotalAfterVAT} placeholder="Address"
                    onChange={(event) => {
                      setTotalAfterVAT(event.target.value)
                      const total = Number(event.target.value)
                      const totalbeforevat = total / 1.13
                      setTotalAmount(totalbeforevat.toFixed(2))
                      const vat = total - totalbeforevat
                      setVAT(vat.toFixed(2))
                    }}
                  />
                </td>
              </tr>
              <tr>
                <td className="col-3">Remarks 1</td>
                <td className="col-6">
                  <input className="input-common"
                    value={Remarks1} placeholder="Remarks 1"
                    onChange={(event) => { setRemarks1(event.target.value) }}
                  />
                </td>
              </tr>
              {Remarks1 !== "" &&
                <tr>
                  <td className="col-3">Remarks 2</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={Remarks2} placeholder="Remarks 2"
                      onChange={(event) => { setRemarks2(event.target.value) }}
                    />
                  </td>
                </tr>
              }
              {Remarks2 !== "" &&
                <tr>
                  <td className="col-3">Remarks 3</td>
                  <td className="col-6">
                    <input className="input-common"
                      value={Remarks3} placeholder="Remarks 3"
                      onChange={(event) => { setRemarks3(event.target.value) }}
                    />
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div className="row center m-2">
            <div className=" col-3" style={{ padding: "0 10px" }}>
              <div className="sign-in-button-4"
                onClick={() => {
                  EditInfo()
                }}
              >
                Update Invoice
              </div>
            </div>
            {ID !== "" &&
              <div className=" col-3" style={{ padding: "0 10px" }}>
                <div className="sign-in-button-4"
                  onClick={() => {
                    invoiceComponentPrint()

                  }}
                >
                  Print Invoice
                </div>
              </div>
            }
          </div>
        </div>
      </div >

      {reload &&
        <div className="modal" style={{ padding: "50vw" }}>
          <div className="dot-pulse"></div>
        </div>
      }
      {
        AlertShow &&
        <AlertComponent Alertcomp={Alertcomp} setAlertShow={setAlertShow} />
      }
      <div 
      // style={{ display: "none" }}
      >
        <div ref={invoiceComponentRef}>

          <section className="bill">
            <header className="top">
              <div className="regd">Regd.: 327859/060/061</div>

              <div className="logo">
                {/* <div className="nea">NEA</div>
            <div className="network">NETWORK</div>
            <div className="academy">EDUCATIONAL ACADEMY</div> */}
                <img src={signInImage} style={{ width: "100px" }} />
              </div>

              <div className="company">
                <h1>Network Educational Academy</h1>
                <h2>Bagbazar-28 Kathmandu</h2>
                <p>Contact : 015921577, 9844085262, 9844832140</p>
                <p>email : info@networkeducationalacademy.com</p>
              </div>

              <div className="right-top">
                <div className="date-line">
                  <label>Date:</label>
                  <div className="underline">{FetchData.date.slice(0,10)}</div>
                </div>
              </div>
            </header>

            <div className="invoice-word">INVOICE</div>

            <div className="form-row row-vat">
              <span className="label">VAT No.</span>

              <div className="box-set" aria-label="VAT number">
                619853527
              </div>

              <span></span>
              {/* <span className="label">Invoice No.</span>
            <input className="invoice-number" value="751" /> */}
            </div>

            <div className="form-row row-name">
              <span className="label">Customer's Name:</span>
              <div className="underline">{Name}</div>
              {/* <input className="underlined" value="Santosh Acharya" /> */}
            </div>

            <div className="form-row row-address">
              <span className="label">Address:</span>
              <div className="underline">{Address}</div>
              {/* <input className="underlined" value="" /> */}
              <span className="label">Invoice No.</span>
              <div className="underline">{InvoiceNo}</div>
              {/* <input className="invoice-number" value="751" /> */}
            </div>

            <div className="form-row row-pan">
              <span className="label">Purchaser VAT/PAN No.</span>

              <div className="box-set" aria-label="Purchaser VAT PAN number">
                <div className="underline">{PanNo}</div>
                {/* <input maxlength="1"><input maxlength="1"><input maxlength="1">
              <input maxlength="1"><input maxlength="1"><input maxlength="1">
                <input maxlength="1"><input maxlength="1"><input maxlength="1"> */}
              </div>

              <span className="payment">Mode of Payment: {ModeofPayment}</span>
              {/* <input className="underlined" style={{ fontSize: "15px" }} value="" /> */}
            </div>

            <table className="items">
              <thead>
                <tr>
                  <th className="sn">S.N.</th>
                  <th className="hs">H.S.Code</th>
                  <th className="particular">Particulars</th>
                  <th className="qty">Qty.</th>
                  <th className="rate">Rate</th>
                  <th className="amount">Amount</th>
                </tr>
              </thead>
              <tbody>
                {Object.values(Items).map((item, index) => (
                  <tr key={index}>
                    <td><div className="number-field" >{index + 1}</div></td>
                    <td><input value="" /></td>
                    <td><div className="number-field" >{item.name}</div></td>
                    <td><div className="number-field" >{item.qty}</div></td>
                    <td><div className="number-field" >{item.rate}</div></td>
                    <td><div className="number-field" >{item.total}</div></td>
                    {/* <td><textarea rows="4">Engineering Course</textarea></td> */}
                    {/* <td><input id="qty" className="number-field" type="number" value="1" oninput="calculate()" /></td> */}
                    {/* <td><input id="rate" className="money" type="number" step="0.01" value="13274.34" oninput="calculate()" /></td> */}
                    {/* <td><input id="lineAmount" className="money" value="13274.34" readonly /></td> */}
                  </tr>
                ))}

              </tbody>
            </table>

            <div className="bottom">
              <div className="words">
                <span className="words-title">In Words:</span>
                <span id="amountWords" className="words-value">{converter.toWords(Number(TotalAfterVAT)).toUpperCase()} RUPEES Only</span>
                {/* <span id="amountWords" className="words-value">Fifteen Thousand Rupees Only</span> */}
              </div>

              <table className="summary">
                <tr>
                  <td className="sum-label">Sub. Total</td>
                  <td><div className="number-field" ></div></td>
                </tr>
                <tr>
                  <td className="sum-label">% Discount</td>
                  <td><div className="number-field" ></div></td>
                </tr>
                <tr>
                  <td className="sum-label">Taxable Amount</td>
                  <td><div className="number-field" >{TotalAmount}</div></td>
                </tr>
                <tr>
                  <td className="sum-label">13% Vat</td>
                  <td><div className="number-field" >{VAT}</div></td>
                </tr>
                <tr>
                  <td className="sum-label">GRAND TOTAL</td>
                  <td><div className="number-field" >{TotalAfterVAT}</div></td>
                </tr>
              </table>
            </div>

            {/* <footer className="footer"> */}
            <div className="footer">
              <div>E. &amp; O. E.</div>
              <div className="signature">
                <div className="signature-space"></div>
                <div className="signature-line">For: Network Educational Academy</div>
              </div>
            </div>
            <div></div>
            {/* </footer> */}
          </section>
        </div>
      </div>

    </div >
  )

}